import React from "react";
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Middle from '../Middle';
import Logo from "Components/Logo";

export default class LoadingIndicator extends React.Component
{
    static propTypes = {
        loading: PropTypes.bool,
        size: PropTypes.oneOf(['s', 'm', 'l'])
    };

    static defaultProps = {
        loading: true,
        size: 'm'
    };

    render()
    {
        if (! this.props.loading) {
            return null;
        }

        const classes = classNames(
            this.props.className,
            {
                'spin opacity-50': true,
                ['w-4']: this.props.size === 's',
                ['w-6']: this.props.size === 'm',
                ['w-8']: this.props.size === 'l',
            }
        );

        return <Middle>
            <Logo className={classes} />
        </Middle>;
    }
}
